import { IconNames } from '@blueprintjs/icons'
import React from 'react'
import * as Sentry from '@sentry/browser'
import config from '../../config'
import FullScreenErrorMessage from '../FullScreenErrorMessage'
import SupportEmailLink from './SupportEmailLink'

export const DefaultError = () => {
  return (
    <FullScreenErrorMessage
      iconName={IconNames.HEART_BROKEN}
      title="Whoops, something went wrong."
      message={
        <p>
          We&apos;re sorry this happened. If you continue to see this screen, please email <SupportEmailLink />.
        </p>
      }
    />
  )
}

export default class AppError extends React.Component {
  state = {
    error: null
  }

  static getDerivedStateFromError = error => ({ error })

  componentDidCatch = (error, info) => {
    this.setState({ error })
    if (config.DEV) {
      console.error('Error:', error)
      console.log('Info:', info)
    }

    if (config.PROD) {
      Sentry.withScope(scope => {
        Object.keys(info).forEach(key => {
          scope.setExtra(key, info[key])
        })
        scope.setUser({
          id: window.user.id,
          username: window.user.username,
          organizationId: window.user.organization.id
        })
        Sentry.captureException(error)
      })
    }
  }

  render = () => (this.state.error ? <DefaultError /> : this.props.children)
}
